import { useInfoPages } from '~/modules/infoPages/uses/useInfoPages';
import { useInfoPageStore } from '~/modules/infoPages/stores/infoPageStore';
import { INFO_PAGES_CONFIG } from '~/modules/infoPages/config';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const infoPages = useInfoPages();
  const infoPagesStore = useInfoPageStore();

  const postUrl = INFO_PAGES_CONFIG.ignoreTrailingSlashInPostsUrls ? to.path.replace(/\/$/, '') : to.path;

  const getPost = () => Object.values(infoPagesStore.detailPosts).find((post) => post.url === postUrl);

  if (getPost()) return;

  const { error } = await useAsyncData(`catch-middleware:${postUrl}`, async () => {
    await infoPages.getDetailPostByFullPath({ fullPath: postUrl, includeHidden: true });

    const post = getPost();
    if (post?.template === 'page') {
      await infoPages.getSectionPosts({ section_id: INFO_PAGES_CONFIG.infoPagesSidebarSectionId, count: 999, page: 1 });
    }

    return null;
  });

  if (error.value || !getPost()) {
    throw createError({ statusCode: 404, statusMessage: 'Page not found', fatal: true });
  }
});
